export default {
  PRODUCT_INFORMATION_REPOSITORY: Symbol.for('PRODUCT_INFORMATION_REPOSITORY'),
  CREATE_PRODUCT_INFORMATION_COMMAND: Symbol.for('CREATE_PRODUCT_INFORMATION_COMMAND'),
};
